// extracted by mini-css-extract-plugin
export var bodySections = "_5z-8";
export var gray = "_5z-7";
export var green = "_5z-4";
export var iconContainer = "_5z-9";
export var iconWidgetContainer = "_5z-1";
export var phoneIcon = "_5z-2";
export var red = "_5z-5";
export var statusDot = "_5z-3";
export var widgetContainer = "_5z-0";
export var yellow = "_5z-6";